.root {
  /* stylelint-disable selector-class-pattern -- Ant Design global .ant-modal-* classes */

  max-width: calc(100vw - 16px);
  color: var(--x-color-text-primary-darker);

  :global {
    .ant-modal-header {
      padding: 16px 24px;
      border: none;
      background-color: var(--x-color-background);
      cursor: move;
    }

    .ant-modal-title {
      color: var(--x-color-text-secondary-darker);
      font-size: 18px;
      font-weight: 700;
    }

    .ant-modal-close-x {
      color: var(--x-color-text-primary-darker);
    }
  }
}

/* isFullHeight prop branch — handled via conditional class (O-04 precedent).
   Constants mirror the original emotion: MODAL_HEADER_HEIGHT 57px,
   MODAL_FULL_HEIGHT_PADDING 80px. */

.fullHeight {
  :global {
    .ant-modal-body {
      height: calc(100vh - 57px - 80px);
      overflow-y: auto;
    }
  }
}

/* isBilling prop branch — min-width override. */

.billing {
  min-width: 950px;
}

/* isFullPage prop branch — full-viewport modal. The `!important` is preserved
   verbatim from the emotion source (Pitfall 4); the body padding override must
   live inside :global so it lands on the Ant .ant-modal-body (Pitfall 2). */

.fullPage {
  top: 10px;

  /* stylelint-disable declaration-no-important -- preserved verbatim from emotion source */
  width: calc(100vw - 16px) !important;
  /* stylelint-enable declaration-no-important */

  padding-bottom: 0;

  :global {
    .ant-modal-body {
      padding: 20px;
    }
  }
}

/* isWarning prop branch — title in the warning red. */

.warning {
  :global {
    .ant-modal-title {
      color: var(--x-color-text-red);
    }
  }
}

/* borderedFooterBorder prop branch — INVERTED logic (Pitfall 3): this class is
   applied when the prop is FALSY, removing the Ant default footer border. */

.noFooterBorder {
  :global {
    .ant-modal-footer {
      border: none;
    }
  }
}

.modalTitle {
  color: var(--x-color-text-secondary-darker);
}
